import { change, formValueSelector } from 'redux-form';
import { findIndex } from 'lodash/array';
import { FORM_NAME } from '%paysera_simple_event/js/event/component/Form/config/constants';

const valueSelector = formValueSelector(FORM_NAME);

function setEventTicketsCount({ hash, count }) {
    return (dispatch, getState) => {
        const ticketTypes = valueSelector(getState(), 'ticket_types');
        const index = findIndex(ticketTypes, { hash });
        dispatch(change(FORM_NAME, `ticket_types[${index}].tickets_count`, count));
    };
}

export default setEventTicketsCount;
